<template>
  <div class="image-select-button">
    <button class="main" @click="onClick" :disabled="disabled">
      <span class="aisea-text-16-400-dark-gray">
        {{ text }}
      </span>
    </button>
  </div>
</template>

<script>
const EVENTS = {
  CLICK: "click",
  CHANGE: "change",
};
export default {
  name: "ImageSelectButton",

  props: {
    text: {
      type: String,
      default: "画像を選択",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit(EVENTS.CLICK);
    },
    onChange(e) {
      this.$emit(EVENTS.CHANGE, e);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.image-select-button {
  // reset button style
  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }
  .main {
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;

    width: 180px;
    height: 50px;
    padding: 13px 22px;

    border-radius: 30px;
    background: #f8f8f8;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.15);

    &:disabled {
      opacity: 0.6;
      pointer-events: none;
    }

    &:hover {
      border-radius: 30px;
      background: $aisea-light-gray;
    }
  }
}
</style>
